module.exports = __webpack_public_path__ + "img/product_12.16f4194.webp";